// extracted by mini-css-extract-plugin
module.exports = {"LockingWrapper":"UILock_LockingWrapper__5lFLh","LockingContent":"UILock_LockingContent__3dh91","LockIcon":"UILock_LockIcon__2Q7ON"};